import { useContext } from 'react';
import { GroupSidebarTags } from '@trinity/chat-components/components/GroupSidebarTags/GroupSidebarTags.js';
import * as Tab from '@/components/presentation/Workspace.Tab.Pane';
import { WorkspaceTranscriptDetailsContext } from '@/containers/Transcript/context';
import { GroupFileTagsContainer } from '@/containers/GroupTags/GroupFileTagsContainer';
import { useGroupEntityTags, useGroupEntityTagsUpdate } from '@trinity/chat-components/contexts/group-tags/hooks/index.js';

type Props = unknown;

export const Details = (props: Props) => {
  return (
    <DetailsContent />
  );
};
Details.displayName = 'Transcript.Tab.Details';

const DetailsContent = (props: Props) => {
  const ctx = useContext(WorkspaceTranscriptDetailsContext);

  const fileId = ctx?.object?.entityId;

  if (!fileId) {
    return null;
  }

  return (
    <div style={{ margin: '20px 0' }}>
      <GroupFileTagsContainer fileId={fileId}>
        <TagPane />
      </GroupFileTagsContainer>
    </div>
  );
};

function TagPane() {

  const tags = useGroupEntityTags();
  const updateTags = useGroupEntityTagsUpdate();

  return (
    <Tab.Pane.Pane>
      <GroupSidebarTags
        tags={tags}
        onSave={updateTags} />
    </Tab.Pane.Pane>
  );
}

DetailsContent.displayName = 'Transcript.Tab.Details.Content';